import React, { useState } from 'react'
import Icon from 'UI/FontAwesomeIcon'

const CopyButton = ({ text, className = '', textToCopy, icon = 'copy', children }) => {
  const [showAlert, toggleAlert] = useState(false)
  const style = { cursor: 'pointer' }
  if (children) {
    style.marginLeft = '5px'
  }
  const copyToClipboard = () => {
    navigator.clipboard.writeText(textToCopy || text)
    toggleAlert(true)
    setTimeout(() => toggleAlert(false), 2000)
  }

  return (
    <span className={`${className} d-inline-flex`} onClick={copyToClipboard}>
      {children}

      <Icon {...{
        icon,
        type: 'fad',
        title: 'Copy',
        style
      }} />

      {showAlert && <span style={{ marginLeft: '5px' }}>Copied</span>}
    </span>
  )
}

export default CopyButton
